/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentFactoryResolver, ComponentRef, Injectable } from '@angular/core';
import { Events } from 'ag-grid-community';
// tslint:disable-next-line:no-submodule-imports
import { ProcessRowParams } from 'ag-grid-community/dist/lib/entities/gridOptions';

import { assign } from 'lodash';
import { AbstractGridOptionBarFeature } from './abstract-grid-option-bar-feature';

import { GridRowInitParams, GridRowOptionsComponent } from './grid-row-options-component';

@Injectable()
export class GridHoverOptionBarFeature extends AbstractGridOptionBarFeature {
  private componentRef: Maybe<ComponentRef<GridRowOptionsComponent>>;
  private currentRow: Maybe<GridRowInitParams>;

  constructor(protected resolver: ComponentFactoryResolver) {
    super();
  }

  process<C extends GridRowOptionsComponent>(params: ProcessRowParams): void {
    const feature = this;

    function mouseEnter(): void {
      feature.createAndAttachComponent(params);
    }

    function mouseLeave(): void {
      feature.detachAndDestroyComponent(params);
    }

    params.eRow.addEventListener('mouseenter', mouseEnter);
    params.eRow.addEventListener('mouseleave', mouseLeave);

    params.addRenderedRowListener(Events.EVENT_VIRTUAL_ROW_REMOVED, () => {
      params.eRow.removeEventListener('mouseenter', mouseEnter);
      params.eRow.removeEventListener('mouseleave', mouseLeave);
    });
  }

  private createAndAttachComponent<C extends GridRowOptionsComponent>(row: GridRowInitParams): void {
    const { currentRow } = this;
    const currentNode = currentRow && currentRow.node.id === row.node.id;
    if (currentNode) {
      return;
    } else {
      this.detachAndDestroyComponent(row);
    }
    const componentRef = this.createComponent();
    this.attachComponent(row, componentRef);

    assign(this, { componentRef, currentRow: row });
  }

  private detachAndDestroyComponent(row: GridRowInitParams): void {
    this.detachComponent(row);
    if (this.currentRow && this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = undefined;
      this.currentRow = undefined;
    }
  }

}
